import React from 'react';
import { View } from 'react-native-web';

import { BrandColor } from '@styleseat/brand';
import { BodyText, HeaderText } from '../../../ui';

import './ReviewEmptyState.module.scss';

const ReviewEmptyState = () => (
  <View styleName="review-empty-state-component">
    <HeaderText level={3} styleName="empty-header-text">
      <HeaderText level={3} color={BrandColor.FloraDark}>0</HeaderText> Reviews
    </HeaderText>
    <BodyText theme="provider" appearance="smaller" styleName="empty-body-text">
      Clients can leave reviews after they have booked and completed a service with you on
      StyleSeat. The more appointments booked, the more reviews you can earn.
    </BodyText>
  </View>
);

export default ReviewEmptyState;
